import type { ReceiptTemplate } from '../schema';

export const neimanMarcusTemplate: ReceiptTemplate = {
  id: 'neiman-marcus',
  name: 'Neiman Marcus Receipt',
  brand: 'NEIMAN MARCUS',
  description: 'Neiman Marcus luxury department store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'nm-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/neiman-marcus.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 16,
        addressLines: [
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
          '(510) 555-0127',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'nm-trans',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'store', label: 'Store:', value: '489' },
          { id: 'trans', label: 'Trans:', value: '847291' },
          { id: 'assoc', label: 'Associate:', value: 'MIKE W.' },
        ],
        column2: [
          { id: 'reg', label: 'Register:', value: '04' },
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'time', label: 'Time:', value: '2:45 PM' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'nm-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'GUCCI GG MARMONT BAG', quantity: '1', price: '2350.00', sku: '847291034' },
          { id: '2', name: 'CASHMERE SCARF', quantity: '1', price: '495.00', sku: '847291035' },
        ],
        showQuantity: true,
        showSku: true,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'nm-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '2845.00', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '234.71', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '3079.71', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'nm-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'NM CREDIT ****4144',
        fields: [
          { id: 'auth', label: 'Approval:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'nm-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'INCIRCLE REWARDS MEMBER\n\nReturns accepted within 30 days\nwith receipt and tags attached\n\nTHANK YOU FOR SHOPPING',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

